import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const useDownloadFile = () => {
  const URL = process.env.REACT_APP_URL; // Ensure this is correctly set in .env
    const selectedConversationData = useSelector((state) => state.conversation);
    const selectedConversationType = selectedConversationData?.conversationType;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadFile = async (messageId, originalFileName) => {
    setIsLoading(true);
    setError(null);

    const fileUrl =
      selectedConversationType === "group"
        ? `${URL}/GroupChat/Download-File/${messageId}`
        : `${URL}/Chats/download/${messageId}`;

    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob", // Handle binary data
      });

      // Extract the filename from the content-disposition header
      const contentDisposition = response.headers["content-disposition"];
      let filename = originalFileName; // Default filename

      if (contentDisposition) {
        // Match both encoded and non-encoded filenames
        const matches = contentDisposition.match(
          /filename\*?=(?:(?:UTF-8'')?([^;]+)|"([^"]+)")/
        );
        if (matches) {
          filename = decodeURIComponent(matches[1] || matches[2] || filename);
        }
      }

      // Create a URL for the blob and trigger the download
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message || "Failed to download the file.");
      console.error("Error downloading file:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return { downloadFile, isLoading, error };
};

export default useDownloadFile;
